import { createAction } from 'deox';

import { ResponseErrors } from 'types';
import {CountriesListProps} from "./types";

export const setUserInfoData = createAction(
  'user/SET_USER_INFO_DATA',
  res => (name: string, value: string) => res({ name, value }),
);

export const getUserInfo = {
  request: createAction('user/GET_USER_INFO'),
  success: createAction('user/GET_USER_INFO_SUCCESS', resolve => (payload: any) =>
    resolve(payload),
  ),
  fail: createAction('user/GET_USER_INFO_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const updateUserInfo = {
  request: createAction('user/UPDATE_USER_INFO'),
  success: createAction('user/UPDATE_USER_INFO_SUCCESS', resolve => (payload: any) =>
    resolve(payload),
  ),
  fail: createAction('user/UPDATE_USER_INFO_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const updateUserPassword = {
  request: createAction('user/UPDATE_USER_PASSWORD'),
  success: createAction('user/UPDATE_USER_PASSWORD_SUCCESS', resolve => (payload: any) =>
    resolve(payload),
  ),
  fail: createAction('user/UPDATE_USER_PASSWORD_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const clearUserError = createAction('user/CLEAR_User_ERROR');

export const setCountry = createAction('user/GET_COUNTRY', res => (payload: string) =>
  res(payload),
);

export const setCountryCode = createAction('user/SET_COUNTRY_CODE', res => (payload: string) =>
  res(payload),
);

export const setCurrency = createAction(
  'user/GET_CURRENCY',
  res => (payload: 'aud' | 'eur' | 'gbp' | string) => res(payload),
);

export const getCreditCardInfo = {
  request: createAction('user/GET_CREDIT_CARD_INFO'),
  success: createAction('user/GET_CREDIT_CARD_INFO_SUCCESS', resolve => (payload: any) =>
    resolve(payload),
  ),
  fail: createAction('user/GET_CREDIT_CARD_INFO_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const createCreditCardInfo = {
  request: createAction('user/CREATE_CREDIT_CARD_INFO', resolve => (paymentMethod: string) =>
    resolve(paymentMethod),
  ),
  success: createAction('user/CREATE_CREDIT_CARD_INFO_SUCCESS', resolve => (payload: any) =>
    resolve(payload),
  ),
  fail: createAction('user/CREATE_CREDIT_CARD_INFO_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const deleteCreditCardInfo = {
  request: createAction('user/DELETE_CREDIT_CARD_INFO', resolve => (id: number) => resolve(id)),
  success: createAction('user/DELETE_CREDIT_CARD_INFO_SUCCESS', resolve => (payload: any) =>
    resolve(payload),
  ),
  fail: createAction('user/DELETE_CREDIT_CARD_INFO_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const getClickCountTotal = {
  request: createAction('user/GET_CLICK_COUNT_REQUEST'),
  success: createAction('user/GET_CLICK_COUNT_SUCCESS', resolve => (payload: number) =>
    resolve(payload),
  ),
  fail: createAction('user/GET_CLICK_COUNT_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const getCountries = {
  request: createAction('user/GET_COUNTRIES_REQUEST'),
  success: createAction('user/GET_COUNTRIES_SUCCESS', resolve => (payload: CountriesListProps[]) =>
    resolve(payload),
  ),
  fail: createAction('user/GET_COUNTRIES_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};
